import dayjs from "dayjs";

export const getOverdueDate = (isAuthenticated, account) => {
  const overdueDate = isAuthenticated && account?.tenant?.overdueDate;
  return overdueDate && !dayjs().isBefore(dayjs(overdueDate), "day")
    ? dayjs(overdueDate)
    : null;
};
